import React, { FC, useState } from 'react';
import { generatePath, useHistory, useParams, useLocation } from 'react-router-dom';
import { LIST_ANALYTICS_CHAPTERS } from '../../../../routes/routeConstants/appRoutes';
import AnalyticsCard from './ AnalyticsCard';
import SubjectsAnalyticsCard from './SubjectsAnalyticsCards';




const StudentAnalytics: FC = () => {
  const history = useHistory();
  const params = useParams()
  const [selected, setSelected] = useState("subject");
  const [loading, setLoading] = useState(true);
  return (
    <div className="institute-student__analytics">
      {/* <AnalyticsCard showPaper={false}/> */}
      {(selected == "subject" || selected == "paper") && <AnalyticsCard
        loading={loading}
        setLoading={(load: boolean) => setLoading(load)}
        showPaper={selected == "paper"}
      />}

      <SubjectsAnalyticsCard
        loading={loading}
        onClick={(id: any, name: string) => {
          history.push({
            pathname: generatePath(LIST_ANALYTICS_CHAPTERS, {
              subjectId: id
            }),
            state: {
              subjectId: id,
              subjectName: name,
            },
          });
        }}
      />

    </div>
  )
}
export default StudentAnalytics;
